import { createContext, useContext, useMemo } from 'react';

import useAutoCallFeature from '@/app/mutations/Shared/useAutoCallFeature';
import { StopOptions } from '@/app/mutations/Shared/types';

export interface Recording {
  isRecording: boolean;
  // A start is dispatched but has not resolved yet.
  isStartPending: boolean;
  start(): void;
  stop(options?: StopOptions): void;
}

export const RecordingContext = createContext<Recording>(null!);

export function useRecording() {
  return useContext(RecordingContext);
}

export function useAutoRecording({ joined }: { joined: boolean }, isEnabled: boolean) {
  const recording = useRecording();
  const feature = useMemo(() => ({
    isActive: recording.isRecording,
    isStartPending: recording.isStartPending,
    start: recording.start,
    stop: recording.stop,
  }), [recording.isRecording, recording.isStartPending, recording.start, recording.stop]);
  useAutoCallFeature({ joined, isEnabled }, feature);
}
